import Rules from './rules.js';
// 表单验证规则
// export const test={
//   name: [
//     { required: true, message: '请输入活动名称', trigger: 'blur' },
//     { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
//   ],
//   region: [
//     { required: true, message: '请选择活动区域', trigger: 'change' }
//   ],
//   date1: [
//     { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
//   ],
//   date2: [
//     { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
//   ],
//   type: [
//     { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
//   ],
//   resource: [
//     { required: true, message: '请选择活动资源', trigger: 'change' }
//   ],
//   desc: [
//     { required: true, message: '请填写活动形式', trigger: 'blur' }
//   ]
// }
// 统一验证函数
export const isValidatorFn=(formName,fn)=>{
  console.log(this.newEventForm);
  this.$refs[formName].validate((valid) => {
    if (valid) {
      // alert('submit!');
      // 验证成功做一些事情
      // 执行fn函数
      fn();
    } else {
      this.$message.error('表单验证未通过！');
      return false;
    }
  });
};
// 验证表单的清除
export const resetForm=(formName)=>{
  this.$refs[formName].resetFields();
};

// 教务 教师添加规则
export const teacherFormRules ={
  username: [
    { required: true, message: '请输入用户名称', trigger: 'blur' },
    { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
  ],
  phone: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    { validator:Rules.isPhone, trigger: 'blur' }
  ],
  passwd: [
    {  required: true, message: '请输入密码', trigger: 'blur' },
    {  validator:Rules.isPassword, trigger: 'blur' }
  ]
};
// pc_banner图规则
export const bannerCreateFormRules={
  device:[
    { required:true,message:'请选择设备信息',trigger:'change' }
  ],
  type:[
    { required:true,message:'请选择图片所属位置',trigger:'change' }
  ],
  addr:[
    { required:true,message:'必须上传一张图片',trigger:'change' }
  ],
  url:[],
  status:[
    { required:true,message:'请选择上线状态',trigger:'change' }
  ]
};
// pc赛事规则
export const eventCreateFormRules={
  device:[
    { required:true,message:'请选择设备信息' }
  ],
  title:[
    { required:true,message:'请输入赛事标题',trigger:'blur' }
  ],
  desp:[
    { required:true,message:'请输入赛事描述',trigger:'change' }
  ],
  logo:[
    { required:true,message:'请上传赛事封面图',trigger:'change' }
  ],
  img:[
    { required:true,message:'请上传赛事主图',trigger:'change' }
  ],
  publish_time:[
    { required:true,message:'请选择发布时间',trigger:'change' }
  ],
  status:[
    { required:true,message:'请选择上线状态',trigger:'change' }
  ]
};

export const fileTestNameRules={
  filename:[
    { required:true,message:'请输入文件名',trigger:'blur' },
    { validator:Rules.isFileTestname,trigger:'blur' }
  ]
};

export const fileTestRenameRules={
  new_name:[
    { required:true,message:'请输入文件名',trigger:'blur' },
    { validator:Rules.isFileTestname,trigger:'blur' }
  ]
};

export const fileTestSaveRules={
  contest:[
    { required:true,message:'文件内容不能为空',trigger:'blur' }
  ]
};

export const questionFormRules={
  title:[
    { required:true,message:'比赛或测验标题不能为空',trigger:'blur' }
  ],
  start_time:[
    { required:true,message:'竞赛开始时间不能为空',trigger:'blur' }
  ],
  end_time:[
    { required:true,message:'竞赛结束时间不能为空',trigger:'blur' }
  ],
  private:[
    { required:true,message:'至少选择一种',trigger:'change' }
  ],
  // password:[
  //   { required:true,message:'私有密码不能为空',trigger:'blur' }
  // ],
  description:[
    { required:true,message:'描述不能为空',trigger:'change' }
  ],
  lang:[
    { required:true,message:'至少选择一种语言',trigger:'blur' }
  ],
  cproblem:[
    { required:true,message:'至少输入一个题目编号',trigger:'blur' }
  ],
  problem_ids:[
    { required:true,message:'至少输入一个题目编号',trigger:'blur' }
  ],
  // ulist:[
  //   { required:true,message:'私有题目，用户不能为空',trigger:'blur' }
  // ],
  type:[
    { required:true,message:'形式不能为空',trigger:'change' }
  ],
  duration:[
    { required:true,message:'时长不能为空',trigger:'blur' }
  ],
  reg_start_time:[
    { required:true,message:'报名开始时间不能为空',trigger:'blur' }
  ],
  reg_end_time:[
    { required:true,message:'报名结束时间不能为空',trigger:'blur' }
  ],
};

// 题单
export const quesListFormRules={
  title:[
    { required:true,message:'题单标题不能为空',trigger:'blur' }
  ],
  description:[
    { required:true,message:'描述不能为空',trigger:'change' }
  ],
  p_id:[
    { required:true,message:'至少输入一个题目编号',trigger:'blur' }
  ],
  tag:[
    { required:true,message:'题单标签不能为空',trigger:'blur' }
  ],
};

// pc
export const pcPlanRules={
  id:[
    { required:true,message:'id不能为空',trigger:'blur' }
  ],
  type:[
    { required:true,message:'科目不能为空',trigger:'change' }
  ],
  title:[
    { required:true,message:'教学标题不能为空',trigger:'blur' }
  ],
  intro:[
    { required:true,message:'教学简介不能为空',trigger:'blur' }
  ],
  logo:[
    { required:true,message:'封面图不能为空',trigger:'change' }
  ],
  content:[
    { required:true,message:'教学内容不能为空',trigger:'change' }
  ],
  plan_title:[
    { required:true,message:'教案规划标题不能为空',trigger:'blur' }
  ],
  plan_logo:[
    { required:true,message:'教案规划封面图不能为空',trigger:'change' }
  ],
  plan_content:[
    { required:true,message:'教案规划内容不能为空',trigger:'change' }
  ],
  status:[
    { required:true,message:'请选择状态',trigger:'change' }
  ],
  publish_time:[
    { type:'string', required:true,message:'请选择发布时间',trigger:'change' }
  ]
};

export const pcGifRules={
  id:[
    { required:true,message:'id不能为空',trigger:'blur' }
  ],
  device:[
    { required:true,message:'设备信息不能为空',trigger:'change' }
  ],
  type:[
    { required:true,message:'请选择图片位置',trigger:'change' }
  ],
  desp:[
    { required:true,message:'图片描述不能为空',trigger:'blur' }
  ],
  addr:[
    { required:true,message:'请上传gif图',trigger:'change' }
  ],
  status:[
    { required:true,message:'请选择状态',trigger:'change' }
  ]
};

export const pcCategorys={
  id:[
    { required:true,message:'id不能为空',trigger:'blur' }
  ],
  device:[
    { required:true,message:'设备信息不能为空',trigger:'change' }
  ],
  name:[
    { required:true,message:'请输入科目名称',trigger:'blur' }
  ],
  update_time:[
    { required:true,message:'请选择发布时间',trigger:'change' }
  ],
  status:[
    { required:true,message:'请选择状态',trigger:'change' }
  ],
  plate:[
    { required:true,message:'请选择发布时间',trigger:'change' }
  ]
};

// oj
export const pcNoticeRules={
  news_id:[
    { required:true,message:'id不能为空',trigger:'blur' }
  ],
  user_id:[
    { required:true,message:'设备信息不能为空',trigger:'blur' }
  ],
  title:[
    { required:true,message:'请输入科目名称',trigger:'blur' }
  ],
  content:[
    { required:true,message:'请选择发布时间',trigger:'change' }
  ]
};

export const pcSubjectRules={
  problem_id:[
    { required:true,message:'id不能为空',trigger:'blur' }
  ],
  time_limit:[
    { required:true,message:'时间限制不能为空',trigger:'blur' }
  ],
  title:[
    { required:true,message:'请输入问题标题',trigger:'blur' }
  ],
  memory_limit:[
    { required:true,message:'内存限制不能为空',trigger:'blur' }
  ],
  description:[
    { required:true,message:'题目描述不能为空',trigger:'change' }
  ],
  input:[
    { required:true,message:'输入不能为空',trigger:'change' }
  ],
  output:[
    { required:true,message:'输出不能为空',trigger:'change' }
  ],
  // hint:[
  //   { required:true,message:'请输入提示内容',trigger:'change' }
  // ]
};

export const pcFicationRules={
  id:[
    { required:true,message:'id不能为空',trigger:'blur' }
  ],
  name:[
    { required:true,message:'类名名称不能为空',trigger:'blur' }
  ],
  pid:[
    { required:true,message:'请选择父级类别',trigger:'change' }
  ],
  update_time:[
    { required:true,message:'请选择发布时间',trigger:'change' }
  ]
};

export const isLoginRules={
  username:[
    { required:true,message:'用户名不能为空',trigger:'blur' }
  ],
  password:[
    { required:true,message:'密码不能为空',trigger:'blur' }
  ]
};
export const isPhone={
  phone:[
    // {  validator:Rules.isPhone, message:'手机号格式错误',trigger: 'change' }
  ]
};

export const isOrder={
  rightstr:[
    {  required: true, message: '请选择权限', trigger: 'change' }
  ]
};